var map = {
	"./BigCheck.svg": "./ClientApp/components/img/BigCheck.svg",
	"./Calendar.svg": "./ClientApp/components/img/Calendar.svg",
	"./Eye.svg": "./ClientApp/components/img/Eye.svg",
	"./JabberLogo.svg": "./ClientApp/components/img/JabberLogo.svg",
	"./Lock.svg": "./ClientApp/components/img/Lock.svg",
	"./Logo.svg": "./ClientApp/components/img/Logo.svg",
	"./Logo1.svg": "./ClientApp/components/img/Logo1.svg",
	"./LogoText.svg": "./ClientApp/components/img/LogoText.svg",
	"./LogoW.svg": "./ClientApp/components/img/LogoW.svg",
	"./MobilyActive.svg": "./ClientApp/components/img/MobilyActive.svg",
	"./MobilyDisabeld.svg": "./ClientApp/components/img/MobilyDisabeld.svg",
	"./STCActive.svg": "./ClientApp/components/img/STCActive.svg",
	"./STCDisabeld.svg": "./ClientApp/components/img/STCDisabeld.svg",
	"./User.svg": "./ClientApp/components/img/User.svg",
	"./ZainActive.svg": "./ClientApp/components/img/ZainActive.svg",
	"./ZainDisabeld.svg": "./ClientApp/components/img/ZainDisabeld.svg",
	"./check.svg": "./ClientApp/components/img/check.svg",
	"./connect.svg": "./ClientApp/components/img/connect.svg",
	"./disConnected.svg": "./ClientApp/components/img/disConnected.svg",
	"./folder.svg": "./ClientApp/components/img/folder.svg",
	"./logoMobily.svg": "./ClientApp/components/img/logoMobily.svg",
	"./logoSTC.svg": "./ClientApp/components/img/logoSTC.svg",
	"./logoTextMobily.svg": "./ClientApp/components/img/logoTextMobily.svg",
	"./logoTextSTC.svg": "./ClientApp/components/img/logoTextSTC.svg",
	"./logoTextZain.svg": "./ClientApp/components/img/logoTextZain.svg",
	"./logoWMobily.svg": "./ClientApp/components/img/logoWMobily.svg",
	"./logoWSTC.svg": "./ClientApp/components/img/logoWSTC.svg",
	"./logoWZain.svg": "./ClientApp/components/img/logoWZain.svg",
	"./logoZain.svg": "./ClientApp/components/img/logoZain.svg",
	"./success_tick_icon.svg": "./ClientApp/components/img/success_tick_icon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./ClientApp/components/img sync recursive ^\\.\\/.*\\.svg$";